export const CREATE_PROJECT_WIZARD_TAG = 'create-project-wizard';

// TODO: cleanup with cp_annotation_createproject_agent ff
export const ANNOTATION_CREATEPROJECT_AGENT_FLAG = 'cp_annotation_createproject_agent';

// TODO: cleanup with cp_disable_asym_alloc_for2_annotators ff
export const CP_DISABLE_ASYM_ALLOC_FOR_2_ANNOTATORS_FLAG = 'cp_disable_asym_alloc_for2_annotators';

export type WizardStepKey =
  | 'basics'
  | 'conceptGroupsAndAttributes'
  | 'datasetImport'
  | 'splittingAndDriftCheck'
  | 'annotationAgent'
  | 'allocation'
  | 'reviewAndCreate';

const CREATE_PROJECT_WIZARD_STEPS: readonly WizardStepKey[] = [
  'basics',
  'conceptGroupsAndAttributes',
  'datasetImport',
  'splittingAndDriftCheck',
  'allocation',
  'reviewAndCreate',
];

// TODO: cleanup with cp_annotation_createproject_agent ff — return the 7-step list unconditionally.
const CREATE_PROJECT_WIZARD_STEPS_WITH_AGENT: readonly WizardStepKey[] = [
  'basics',
  'conceptGroupsAndAttributes',
  'datasetImport',
  'splittingAndDriftCheck',
  'annotationAgent',
  'allocation',
  'reviewAndCreate',
];

/**
 * Ordered step keys of the create-project wizard. Each step's locale keys live under
 * `createProjectWizard.step.<key>`.
 */
export const getCreateProjectWizardSteps = (
  isAgentStepEnabled: boolean
): readonly WizardStepKey[] =>
  isAgentStepEnabled ? CREATE_PROJECT_WIZARD_STEPS_WITH_AGENT : CREATE_PROJECT_WIZARD_STEPS;

export const CREATE_PROJ_SUCCESS_MODAL_TIMEOUT = 5;

export const DATA_IMPORT_MODES = ['file-upload', 's3-path'] as const;
